<h1 class="fw-bold">{{ shouldTranslate ? (text | translate) : text }}</h1>